import { AccessTokenStorage, configureStorage } from './storage';

export const extractAccessTokenFromWindowLocation = (window?: Window | null) => {
    if (!window || !window.location || !window.location.href) {
        return undefined;
    }

    if (typeof window.location.href !== 'string') {
        return undefined;
    }

    let token;
    window.location.href.replace(/access_token=([^&]+)/u, (_: unknown, it: string) => {
        return (token = it);
    });

    return token;
};

export const configureAccessToken = (
    storage: AccessTokenStorage,
    window?: Window | null,
): AccessTokenStorage => {
    const urlToken = extractAccessTokenFromWindowLocation(window);

    if (urlToken) {
        storage.saveAccessToken(urlToken);
    }

    return storage;
};

export const accessToken = configureAccessToken(
    configureStorage(),
    typeof window === 'undefined' ? null : window,
);
